<template lang="pug">
.medication-table.mb-12
  v-data-table(:key="tableKey" :headers="headers" :items="medications" hide-default-footer :items-per-page="-1" disable-sort :loading="isLoading" fixed-header)
    template(v-slot:item.number="{ item }")
      .d-flex.align-start.fill-height
        .text-xs.font-bold.neutral500--text.my-4 {{ item.number }}
    template(v-slot:item.productItem="{ item }")
      .my-4
        .d-flex.align-center
          v-icon.mr-2(v-if="item.isChild" size="18" color="neutral700" style="margin-bottom: 6px;") $yzi-corner-down-right
          .text-sm.font-semibold.neutral700--text {{ item.name }}
            span.ml-1(v-if="item.uom") ({{ item.uom }})
        template(v-if="hasInstructionPrecaution(item)")
          v-row(no-gutters)
            v-col(cols="4")
              .text-xs.font-medium.neutral500--text.mt-1 {{ $t('instruction') }}
            v-col
              .text-xs.font-medium.mt-1 {{ getInstruction(item) }}
          v-row(no-gutters)
            v-col(cols="4")
              .text-xs.font-medium.neutral500--text.mt-1 {{ $t('side_effect') }}
            v-col
              .text-xs.font-medium.mt-1 {{ getPrecaution(item) }}
    template(v-slot:item.quantity="{ item }")
      .d-flex.align-start.fill-height
        .text-sm.font-normal.my-4 {{ item.quantity }}
    template(v-slot:item.totalPrice="{ item }")
      .d-flex.align-start.fill-height(:class="[{ 'justify-end':hideActions }]")
        .text-sm.font-normal.my-4 {{ item.totalPrice | displayPrice }}
    template(v-slot:item.action="{ item }")
      .d-flex.align-start.fill-height
        .my-3
          v-btn.mr-1(icon small @click="onEditMedication")
            v-icon(size="16") $yzi-edit-05
          v-btn.mr-1(v-if="!item.isChild" icon small @click="onDeleteTreatment(item)")
            v-icon(size="16") $yzi-trash-03
          v-btn(v-if="canPrint(item)" icon small @click="onPrint(item)")
            v-icon(size="16") $yzi-printer
  .dialogs
    delete-confirmation-dialog(v-if="openDeleteConfirmationDialog" :open.sync="openDeleteConfirmationDialog" :loading="isDeletingTreatment" @cancel="onCancelDeleteTreatment" @delete="onConfirmDeleteTreatment")
      delete-confirmation-details(:selectedTreatment="selectedTreatment")
  </template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import DeleteConfirmationDetails from '@/components/clinic/invoice/DeleteConfirmationDetails.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'

export default {
  components: {
    DeleteConfirmationDialog, DeleteConfirmationDetails
  },
  props: {
    parentMedications: {
      type: Array,
      default: () => {
        return []
      }
    },
    hideActions: {
      type: Boolean
    }
  },
  data() {
    return {
      isLoading: false,
      tableKey: 0,
      payloadKey: 0,
      medications: [],
      selectedTreatment: null,
      openDeleteConfirmationDialog: false,
      isDeletingTreatment: false
    }
  },
  mounted () {
    this.mapData()
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    leadPid() {
      return this.$route.params.pid
    },
    headers () {
      let headers = [
        { text: '#', value: 'number', width: 10 },
        { text: 'Item', value: 'productItem', width: '20vw', align: 'start' },
        { text: 'Qty', value: 'quantity' },
        { text: 'Total Price', value: 'totalPrice' },
      ]
      if (this.hideActions) {
        // Change width of item
        headers[1].width = '65%'
        // Add align end to total price
        headers[3].align = 'end'
      } else {
        headers.push({ text: 'Action', value: 'action' })
      }

      return headers
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    mapData() {
      if (this.parentMedications.length === 0) {
        return
      }
      // this.medications = this.parentMedications.map((medication, index) => this.filterMapData(medication, index))
      // this.medications = 
      this.parentMedications.forEach((medication, index) => {
        if (medication.bundles.length) {
          medication.isParent = true
        }
        this.medications.push(this.filterMapData(medication, index + 1))
        medication.bundles.forEach(bundle => {
          bundle.isChild = true
          bundle.parentId = medication.id
          this.medications.push(this.filterMapData(bundle))
        })
      })
    },
    filterMapData(obj, number) {
      const allowedProperties = ['id', 'name', 'quantity', 'extra_data', 'type']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      filteredObj.number = number || null
      filteredObj.type = obj.product.type
      filteredObj.uom = obj.product.uom
      filteredObj.medication = obj.product.medication
      filteredObj.totalPrice = obj.price * obj.quantity
      if (obj.isParent) { filteredObj.isParent = true }
      if (obj.isChild) {
        filteredObj.isChild = true
        filteredObj.parentId = obj.parentId
      }
      return filteredObj
    },
    // isMedicineType (item) {
    //   if (item.medication && ['medication', 'consumable'].includes(item.medication.category)) {
    //     return true
    //   }
    //   return false
    // },
    hasValue(value) {
      if (typeof value === 'string') {
        value = value.trim()
      }
      return value !== null && value !== undefined && value !== ''
    },
    hasInstructionPrecaution (item) {
      if (this.hasValue(item.extra_data.dosage_value) && this.hasValue(item.extra_data.dosage_unit)) {
        return true
      }
      if (this.hasValue(item.extra_data.frequency)) {
        return true
      }
      if (this.hasValue(item.extra_data.instruction)) {
        return true
      }
      if (this.hasValue(item.extra_data.precaution)) {
        return true
      }
      return false
    },
    getInstruction (item) {
      let result = []
      if (this.hasValue(item.extra_data.dosage_value) && this.hasValue(item.extra_data.dosage_unit)) {
        result.push(`${item.extra_data.dosage_value} ${item.extra_data.dosage_unit}`)
      }
      if (this.hasValue(item.extra_data.frequency)) {
        result.push(item.extra_data.frequency)
      }
      if (this.hasValue(item.extra_data.instruction)) {
        result.push(item.extra_data.instruction)
      }
      return result.length > 0 ? result.join(', ') : '-'
    },
    getPrecaution(item) {
      return item.extra_data.precaution ?? '-'
    },
    onEditMedication() {
      // this.$router.push(`/admin/clinic/invoice/${this.leadPid}?origin=checkout`)
      let next = {
        name: this.isHq ? 'HQInvoice' : 'ClinicInvoice',
        params: {
          pid: this.leadPid,
          origin: this.isHq ? 'HQCheckout' : 'ClinicCheckout',
          data: {
            params: { ...this.$route.params }
          }
        }
      }
      this.$router.push(next)
    },
    canPrint (item) {
      if (this.hasInstructionPrecaution(item)) {
        return true
      }
      if (item.type === 'documents') {
        return true
      }
      return false
    },
    async onPrint (item) {
      // if (this.isMedicineType(item)) {
      //   try {
      //     await this.$axios.post(`/clinics/${this.company.slug}/registrations/${this.leadPid}/print`, { leadproduct: item.id })
      //     this.showMessage(['success', this.$t('success_message.successfully_send_to_printer')])
      //   } catch (error) {
      //     const errorData = error.response?.data?.detail
      //     if (errorData && errorData === 'Default printer not set') {
      //       this.$router.push('/admin/clinic/settings/hardware/printers')
      //       this.showMessage(['error', 'Please set your default printer'])
      //     } else {
      //       this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      //     }
      //   }
      //   return
      // }
      let key
      try {
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }
      let baseUrl = process.env.VUE_APP_BASE_URL
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseUrl = 'https://api-test.yezza.io'
      } else if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      const url = `${baseUrl}/clinics/${companySlug}/registrations/${this.leadPid}/preview_document?leadproduct=${item.id}&key=${key}`
      window.open(url,'_blank')
    },
    onDeleteTreatment(item) {
      this.selectedTreatment = item
      this.openDeleteConfirmationDialog = true
    },
    onCancelDeleteTreatment() {
      this.selectedTreatment = null
      this.openDeleteConfirmationDialog = false
    },
    async onConfirmDeleteTreatment() {
      try {
        this.isDeletingTreatment = true
        const id = this.selectedTreatment.id
        const endpoint = `/leads/${this.leadPid}/products/${id}`
        await this.$axios.delete(endpoint)
        this.updateActivityLog(endpoint, null, null, 'DELETE', id)
        this.$emit('updated')
        this.showMessage(['success', this.$t('success_message.successfully_updated')])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isDeletingTreatment = false
        this.openDeleteConfirmationDialog = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: 'invoice',
        activity: 'Update medication table',
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
/* ::v-deep table > tbody > tr > td:nth-child(1),
::v-deep table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 10;
  background: white;
}
::v-deep table > tbody > tr > td:nth-child(2),
::v-deep table > thead > tr > th:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 40px;
  z-index: 10;
  background: white;
}
::v-deep table > thead > tr {
  position: sticky !important;
  position: -webkit-sticky !important;
  top: 0;
  z-index: 11;
  background: white;
} */
</style>